import { Component } from '@angular/core';
import { SharedService } from './services/shared.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor (public sharedService: SharedService, public afAuth: AngularFireAuth, private router: Router) {
    afAuth.authState.subscribe(login => {
      if (!login) {
        router.navigate(['login']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts